import React from 'react';
import { taskScrollSettings } from '../../../../constants/copyright';
import Toggle from '../../../baseComponents/gui/toggle/Toggle';
import { Scrollbar } from 'react-scrollbars-custom';

const ShelfToggle = React.forwardRef(function ShelfToggle({ toggleList, shelfCallbacks }, ref) {
  return (
    <div className={'shelf__toggle-wrapper'}>
      <Scrollbar {...taskScrollSettings}>
        <Toggle list={toggleList} funcs={shelfCallbacks} mod={'wide-2'} />
      </Scrollbar>
    </div>
  );
});
export default ShelfToggle;
ShelfToggle.propTypes = {};
